<it-card teaser="true" shadow="true">
  <div class="row">
    <div class="col">
      <it-alert color="danger">
        Da questa pagina puoi annullare la richiesta di transizione. Per
        procedere è necessario inserire una breve motivazione.
      </it-alert>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <div class="row">
        <p class="example-section">
                  <it-select
                    id="default-select"
                    label="Causale"
                    [(ngModel)]="type"
                  >
                  <option [ngValue]="null">Seleziona una causale</option>
                    <option *ngFor="let cause of causes"
                    [value]="cause.id">
                      {{ cause.name }}
                    </option>
                  </it-select>
        </p>
      </div>
    </div>
    <div class="col">
      <div class="mt-2">
        <it-textarea
            [rows]="5"
            description="Note annullamento"
            [(ngModel)]="note"
        ></it-textarea>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button itButton="outline-primary" type="button" (click)="cancel()">
          Torna indietro
        </button>
        <button
          itButton="danger"
          type="button"
          [disabled]="!type"
          (click)="confirm()"
        >
          Annulla la richiesta di transizione
        </button>
      </div>
    </div>
  </div>
</it-card>
